import { render, staticRenderFns } from "./il-widget-tester.vue?vue&type=template&id=23ed4428"
import script from "./il-widget-tester.vue?vue&type=script&lang=ts"
export * from "./il-widget-tester.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports